var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.success !== undefined)?_c('span',{staticClass:"success"}):_vm._e(),(_vm.warning !== undefined)?_c('span',{staticClass:"warning"}):_vm._e(),(_vm.danger !== undefined)?_c('span',{staticClass:"danger"}):_vm._e(),(_vm.info !== undefined)?_c('span',{staticClass:"info"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }